// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1uWaX","errors":"Errors_errors__2YK-r"};